"use client";

import { c as _c } from "react/compiler-runtime";
import { trackEmailComposerAction } from "../../analytics";
import { useEmailComposer } from "../../context";
import { useRef } from "react";
import { LuPaperclip } from "react-icons/lu";
import { Button } from "@/components/ui";
export function AttachmentButton() {
  const $ = _c(4);
  const {
    onAddFiles
  } = useEmailComposer();
  const fileInputRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => fileInputRef.current?.click();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Button type="button" variant="ghost" size="icon-sm" onClick={t0} tooltip="Attach file"><LuPaperclip size={16} /></Button>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onAddFiles) {
    t2 = <>{t1}<input ref={fileInputRef} type="file" multiple={true} className="hidden" onChange={e => {
        const files = Array.from(e.target.files ?? []);
        if (files.length > 0 && onAddFiles) {
          onAddFiles(files);
          trackEmailComposerAction("file_attached", "toolbar", {
            num_files: files.length
          });
        }
        e.target.value = "";
      }} /></>;
    $[2] = onAddFiles;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}